import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { ReportUserSignature } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { Button } from '@/shared/ui';

import { ReportSign } from '../ReportSign/ReportSign';

import styles from './ReportSigns.module.scss';

type ReportSignsProps = {
  signedUsers: ReportUserSignature[];
  className?: string;
  onRemoveSignature?: () => void;
};

const sortSignedUsers = (a: ReportUserSignature, b: ReportUserSignature) => {
  const aSignedAt = a.SignedAt?.toDate().getTime() ?? 0;
  const bSignedAt = b.SignedAt?.toDate().getTime() ?? 0;

  return bSignedAt - aSignedAt;
};

export const ReportSigns: FC<ReportSignsProps> = (props) => {
  const { signedUsers, className, onRemoveSignature } = props;

  const sortedSignedUsers = [...signedUsers].sort(sortSignedUsers);

  return (
    <div
      className={cn(styles.container, className)}
      data-section="report-signed-users"
    >
      <div className={styles.header}>
        <h5 className={cn(styles.signedTitle, 'h5')}>
          <FormattedMessage
            id="report.signedByReport"
            defaultMessage="Report signed by"
          />
        </h5>

        {onRemoveSignature && (
          <Button variant="tertiary" size="small" onClick={onRemoveSignature}>
            <FormattedMessage
              id="report.removeSignature"
              defaultMessage="Remove signature"
            />
          </Button>
        )}
      </div>

      {sortedSignedUsers.map((user) => (
        <ReportSign key={user.UserID} user={user} />
      ))}
    </div>
  );
};
